/* eslint-disable eqeqeq */

import React, { useState, useEffect,useImperativeHandle, forwardRef } from 'react';
import { Responsive, WidthProvider } from "react-grid-layout";
import swal from 'sweetalert';
import { httpPost } from '../../../store/externalCalls/httpCalls';
import { getCanvasBlockSize, permittedSizes, permittedSizesSmall, positionCandidates, randomNumberInRange } from '../../../utils/canvasUtils';
import Button, { ButtonSize } from '../../atoms/button/button';
import MoveIcon from '../../atoms/customIcons/moveIcon.svg';
import { IconSize, IconType } from '../../atoms/icon/icon';
import CanvasContentComponent from './canvasContentComponent';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { storeStructure } from '../../../store/reducers';
import { removeCanvasContentInfo } from '../../../store/actions/canvasContentInfoActions';

let timeoutId=null;
const ResponsiveGridCanvas = WidthProvider(Responsive);
/**
 * Canvas Blocks component
 */
const CanvasBlocksComponent = forwardRef((props,ref) => {
    const {
        containerId,
        canvasId,
        mode,
        canvasMode,
        value,
        infoContent,
        allBlocks,
        dateSelected,
        blockSelected,
        newBlockTrigger,
        onUpdateBlocks,
        onDeleteBlocks,
        onInfoClicked,
        onBlockSelected,
        onUpdateInfoContent,
    } = props;

    const [blockGrid,setBlockGrid] =useState(false);
    const [board, setBoard] = useState(null);
    const CanvasInfoContent = useSelector((state) => state[storeStructure.CanvasContentInfo], shallowEqual);
    const dispatch = useDispatch();

    // useEffect(()=>{
    //   if(newBlockTrigger){
    //     handleAddBlock(containerId);
    //   }
    // },[newBlockTrigger]);

    useEffect(() => {
      if(value!=='' && value!==board){
        setBoard(value);
        checkCanCreateNewItem(value);
      }
    }, [value,infoContent]);
    
    const findEmptyPosition = (board) => {
      let selectedPosition;
      for(let  i = 0; i < positionCandidates(canvasMode).length; i++){
          const positionCandidate = positionCandidates(canvasMode)[i];
          const boardItemInPosition = board.find((boardItem) => {
            const boardItemMaxX = boardItem.x + boardItem.w - 1;
            const boardItemMaxY = boardItem.y + boardItem.h - 1;
            return boardItem.x <= positionCandidate[0] 
              && boardItemMaxX >= positionCandidate[0] 
              && boardItem.y <= positionCandidate[1]
              && boardItemMaxY >= positionCandidate[1];
          });
          if(!boardItemInPosition){
            selectedPosition = positionCandidate;
            break;
          }
      }
      return selectedPosition;
    };
    
    const checkCanCreateNewItem = (newBoard) => {
      let createStatus=findEmptyPosition(newBoard) !== undefined;
      return createStatus;
    };
    useImperativeHandle(ref,(contId)=>({
      handleAddBlock(contId){
        const selectedPosition = findEmptyPosition(board);
        if(selectedPosition){
          const newUID=randomNumberInRange(100000000000,999999999999);//Math.floor(Math.random()*10000);
          let newItem={
            UID: newUID,
            x: selectedPosition[0],
            y: selectedPosition[1],
            canvasContainerId:contId,
            w:1,
            h:1,
            contents:null,
            new:true,
            size:getCanvasBlockSize(1,1)
          };
          let params={"block":newItem,"allBlocks":allBlocks,"dateSelected":dateSelected};
          httpPost('canvasCheckBlock', params).then((res)=>{
            newItem["startEpoch"] = res["block"]["startEpoch"];
            newItem["endEpoch"] = res["block"]["endEpoch"];
            let newBoard = [
              ...board,
              newItem          
            ];
          let createStatus=checkCanCreateNewItem(newBoard);
            onUpdateBlocks(newBoard,createStatus); 
            setBoard(newBoard); 
          }).catch(error=>{
            console.log("error");
          });  
        } else
          alert("you can´t add more blocks on this container");
        }
      }
    ));
    
    const handleRemoveBlockAction = (block) => {
      let filteredUpdate = board.filter((elemBlock) => { 
        if(block.UID !== elemBlock.UID){
          return elemBlock;
        }else{
          if(block.startEpoch!=dateSelected){
            elemBlock.endEpoch=dateSelected;
            return elemBlock;
          }
        }
      });
      let filteredBoard = board.filter((elemBlock) => { 
        if(block.UID !== elemBlock.UID)
          return elemBlock
      });
      if(block.startEpoch==dateSelected){
        onDeleteBlocks(block);
      }else
        onUpdateBlocks(filteredUpdate,true);
      setBoard(filteredBoard);
    };

    const isResizedBlock=(block1,block2)=>{
      if(block1.x!=block2.x || block1.y!=block2.y || block1.w!=block2.w || block1.h!=block2.h){
        return true;
      }
      return false;
    }
    const handleResize = (canvas, oldCanvasItem, canvasItem, placeholder) => {
      let permitted=null;
      if(canvasMode=="Middle")
        permitted=permittedSizes;
      if(canvasMode=="Top" || canvasMode=="Bottom")
        permitted=permittedSizesSmall; 

      if(!permitted.includes(canvasItem.w+'x'+canvasItem.h)){
        canvasItem.w = 1;
        canvasItem.h =1;
        placeholder.w = 1;
        placeholder.h=1;
      }
    };
    const handleResizeStop = (canvas, oldCanvasItem, canvasItem, placeholder) => {
      let blockResized=null;
      let chunkOld=null;
      
      canvas.map(block=>{
        board.map(boardItem=>{
          if(block.i == boardItem.UID){
            block["UID"]=boardItem.UID;
            block["startEpoch"]=boardItem.startEpoch;
            block["endEpoch"]=boardItem.endEpoch;
            block["contents"] = boardItem.contents;
           
            if(isResizedBlock(block,boardItem)){
              block["contents"] = boardItem.contents;
              if(block["contents"] && block["contents"]["info"]){
                block["contents"]["info"]=null;
              }
              
              block["size"] =getCanvasBlockSize(block.w,block.h);
              block["new"]=boardItem.new;
              //if the block is in the beginning point
              if(dateSelected!=boardItem.startEpoch){
                chunkOld={...block};
                chunkOld["UID"]=randomNumberInRange(100000000000,999999999999);
                chunkOld["x"] = boardItem.x;
                chunkOld["y"] = boardItem.y;
                chunkOld["w"] = boardItem.w;
                chunkOld["h"] = boardItem.h;
                chunkOld["i"] ="old";
                chunkOld["startEpoch"]=boardItem.startEpoch;
                chunkOld["endEpoch"]=dateSelected;
                chunkOld["contents"] =(boardItem.contents?{...boardItem.contents}:null);
                if(boardItem.contents){
                  chunkOld["contents"]["UID"]=randomNumberInRange(100000000000,999999999999);
                }
                block["startEpoch"]=dateSelected;
                block["endEpoch"]=boardItem.endEpoch;
              }
              if(block && block["contents"] && block["contents"]["UID"]){
                let found=CanvasInfoContent.find((item)=>item.UID==block["contents"]["UID"]);
                if(found){
                  dispatch(removeCanvasContentInfo([found]));
                }
              }
              blockResized=block;
            }
          }
        });
      });
      if(chunkOld!=null)
        canvas=[...canvas,chunkOld];
      
      let createStatus=checkCanCreateNewItem(board);
      clearTimeout(timeoutId);
      timeoutId = setTimeout(()=>{
        let params={"block":blockResized,"allBlocks":allBlocks,"dateSelected":dateSelected};
        if(blockResized!=null){
          httpPost('canvasCheckBlock', params).then((res)=>{
            blockResized["startEpoch"]=res["block"]["startEpoch"];
            blockResized["endEpoch"] =res["block"]["endEpoch"];
            let filteredCanvas = canvas.filter((block) => { 
              if(blockResized.UID === block.UID){
                return blockResized;
              }else{
                return block;
              }
            });
           
            if(chunkOld!=null){
              let indexDelete = canvas.findIndex((item)=>item.UID===chunkOld.UID);
              if(indexDelete>=0){
                canvas.splice(indexDelete,1);
              }
            }
            createStatus=checkCanCreateNewItem(canvas);
            onUpdateBlocks(filteredCanvas,createStatus);
            setBoard(canvas);
          }).catch(error=>{
            console.log("error",error);
          });
        }else{
          //DELETED TO AVOID SHOW CHANGES MADE WHEN NOT
          // onUpdateBlocks(canvas,createStatus);
          // checkCanCreateNewItem(board);
          // setBoard(canvas);
        }
      },0);
    };
    
    const handleRemoveBlock = (block) => {
      setBlockGrid(true);
      swal({
        title: 'Are you sure?',
        text: 'You are about to remove a block, and there´s no way back from this action',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((ok) => {
        if(ok){
          handleRemoveBlockAction(block);
          setBlockGrid(false);
        }
      });   
    };

    const handleBlockBlocks=(value)=>{
      setBlockGrid(value);
    }

    const handleInfoClicked=(value)=>{
      onInfoClicked(value);
    }
    const handleUpdateInfoContent=(newElem,infoContent)=>{
      onUpdateInfoContent(newElem,infoContent);

    }
    const handleUpdateContent=(block)=>{
      let updateBoard=[...board];
      updateBoard.map(boardItem=>{
          if(block.i == boardItem.UID){
            boardItem.contents=block["contents"]
            boardItem.size =block["size"]
            boardItem.UID=block["UID"]
          }
        });
      onUpdateBlocks(updateBoard,true);
      setBoard(updateBoard);
    }

    const handleCopyBlock=()=>{
      alert("copy block TBD");
    }
    const handleSelectBlock=(UID)=>{
      onBlockSelected(UID);

    }
    
    return (
         <div className={"grid-block"+(value.init?" block-init":"")}>
            {board && <ResponsiveGridCanvas
                className="canvas canvas-block"
                cols={{ lg: 4, md: 4, sm: 4, xs: 4, xxs: 4 }}
                canvas={board}
                isBounded={true}
                width={20}
                maxRows={4}
                rowHeight={85}
                preventCollision={true}
                compactType={null}
                draggableHandle=".header-block"
                isDraggable={!blockGrid}
                isResizable={!blockGrid}
                onResize={handleResize}
                onResizeStop={handleResizeStop}
                onDragStop={handleResizeStop}
              >
              {board && board.map((block, key)=>{
                  return (
                    <div key={block.UID} data-grid={block} data-uid={block.UID}>
                      {mode==2 && <div className={"block block--preview"}>
                      <CanvasContentComponent 
                          canvasId={canvasId?canvasId:null}
                          mode={mode}
                          canvasMode={canvasMode}
                          size={getCanvasBlockSize(block.w,block.h)} 
                          value={block} 
                          infoContent={infoContent}
                          onUpdateContent={handleUpdateContent}
                          onInfoClicked={handleInfoClicked} 
                          onBlockBlocks={handleBlockBlocks}
                          blockSelectedPreview={blockSelected}
                          onUpdateInfoContent={handleUpdateInfoContent}
                           />
                      </div>}
                      {mode==1 && <div className={"block"}>
                        <div className="header">
                          <div className={"header-block"+(block.UID==blockSelected?' block-selected':'')} onClick={()=>{handleSelectBlock(block.UID)}}>
                            <div className="header-row">
                              <img className="icon" src={MoveIcon} />
                            </div> 
                            <div className="header-row">
                              {getCanvasBlockSize(block.w,block.h)}
                            </div>
                            
                          </div>
                          <div className="header-actions-block">
                            {/* <Button
                              id={'button-copy-block'}
                              className="button-action"
                              type={'button'}
                              onClick={handleCopyBlock}
                              icon={IconType.COPY}
                              iconSize={IconSize.SMALL}
                              iconColor={"#000000"}
                              size={ButtonSize.SMALL}
                            >
                            </Button> */}
                            <Button
                              id={'button-delete-block'+block.UID}
                              className="button-action button-delete-block"
                              type={'button'}
                              onClick={()=>{handleRemoveBlock(block)}}
                              icon={IconType.DELETE}
                              iconSize={IconSize.SMALL}
                              iconColor={"#000000"}
                              size={ButtonSize.SMALL}
                            >
                            </Button>
                          </div>  
                        </div>
                        <div className={'body-block'+ ' block-size '+(block.UID==blockSelected?' block-selected':'')}>
                          <CanvasContentComponent
                            canvasId={canvasId?canvasId:null}
                            isInit={(block.startEpoch==dateSelected?true:false)} 
                            mode={mode}
                            canvasMode={canvasMode}
                            containerId={containerId}
                            size={getCanvasBlockSize(block.w,block.h)} 
                            value={block} 
                            infoContent={infoContent}
                            onUpdateContent={handleUpdateContent}
                            onInfoClicked={handleInfoClicked} 
                            onBlockBlocks={handleBlockBlocks}/>
                        </div>
                      </div>}
                    </div>    
                  )
                })
                }
            </ResponsiveGridCanvas>}
        </div>
    );
});
CanvasBlocksComponent.propTypes = {
  // blockSelected:propTypes.number
};

CanvasBlocksComponent.defaultProps = {
    // container:{},
    // name:'',
    // type:'staticImage'
    blockSelected:null
  };
export default CanvasBlocksComponent;
